<template>
  <div class="receipt">
    <span class="receipt__date">{{currentReceipt.month}} {{currentReceipt.year}}</span>
    <div class="receipt__img">
      <img :src="src" alt="Квитанция">
    </div>

    <div class="receipt-controller">
      <div class="receipt-controller__left">
        <v-btn :disabled="!receiptPdf" class="receipt-controller__btn" @click="download">Скачать ЕПД</v-btn>
        <a class="receipt-controller__link" href="/payments/statement/plug">Подписаться на электронный ЕПД</a>
      </div>
      <payment-btn v-model="prePayment" class="receipt-controller__right"/>
    </div>
  </div>
</template>

<script>
  import PaymentBtn from '../../common/PaymentBtn'
  import {mapState} from 'vuex'

  export default {
    name: 'Receipt',
    components: {PaymentBtn},
    data: () => ({
      fileName: 'receipt.pdf',
      prePayment: null
    }),
    computed: {
      src() {
        return 'data:image/png;base64,' + this.currentReceipt.file
      },
      link: function () {
        const link = document.createElement('a');
        link.innerHTML = 'Download PDF file';
        link.download = this.fileName;
        link.href = 'data:application/pdf;base64,' + this.receiptPdf;
        return link
      },
      ...mapState('account', ['selectedAccount']),
      ...mapState('payments', ['currentReceipt', 'receiptPdf'])
    },
    watch: {
      selectedAccount: {
        immediate: true,
        handler: function (value) {
          this.$store.dispatch('payments/getCurrentReceipt', {domHoz: value.domHoz})
        }
      },
      currentReceipt(value) {
        this.$store.dispatch('payments/getReceiptPdf', {domHoz: this.selectedAccount.domHoz})
        this.prePayment = String(value.prePayment.toFixed(2)).replace('.', ',')
      }
    },
    methods: {
      download() {
        this.link.click()
      }
    },
    mounted() {

    }
  }
</script>

<style lang="scss" scoped>
  .receipt {
    position: relative;
    width: 100%;

    &__img {
      padding-bottom: 30px;
      position: relative;
      width: 100%;

      img {
        width: 100%;
      }
    }

    &__date {
      color: $main-green;
      font-size: 20px;
      font-weight: 500;
      position: absolute;
      bottom: calc(100% + 22px);
      right: 0;
    }
  }

  .receipt-controller {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    &__left {
      display: flex;
      align-items: center;
    }

    &__btn {
      @extend %b-btn;
      margin-right: 20px;
      margin-bottom: 30px;
    }

    &__link {
      display: block;
      @extend %link;
      margin-bottom: 30px;
    }
  }
</style>
